import React, { useState } from 'react';
import { RiWallet3Line } from 'react-icons/ri';
import FilterDropdown from './FilterDropdown';

//* value stays "min-max" – HouseList splits it on "-" when filtering
const formatPrice = (amount) => `$${Number(amount).toLocaleString('en-US')}`;
const priceRange = (min, max) => ({
    label: `${formatPrice(min)} – ${formatPrice(max)}`,
    value: `${min}-${max}`,
});

const priceOptions = [
    { label: 'Price range (any)', value: 'Price range (any)' },
    priceRange(100000, 130000),
    priceRange(130000, 160000),
    priceRange(160000, 190000),
    priceRange(190000, 250000),
];

const PriceRangeDropdown = ({ onChange, isOpen, onToggle, onClose, className }) => {
    const [value, setValue] = useState(null);

    const handleSelect = (option) => {
        setValue(option);
        onClose();
        if (onChange) {
            onChange(option);
        }
    };

    return (
        <FilterDropdown
            icon={RiWallet3Line}
            label="Price range"
            value={value}
            options={priceOptions}
            isOpen={isOpen}
            onToggle={onToggle}
            onClose={onClose}
            onSelect={handleSelect}
            className={className}
        />
    );
};

export default PriceRangeDropdown;
